<template>
  <van-dialog
    :show="showNotify"
    confirm-button-color="#007AFF"
    class="processing-tv360-dialog"
    :show-confirm-button="false"
  >
    <template #title style="padding-bottom: 2px;">
      <div class="processing-tv360-dialog__icon">
        <img src="@/static/icon-processing.png" alt="processing" />
      </div>
      <div class="processing-tv360-dialog__title" style="padding-top: 4px;">
        {{ displayTitle }}
      </div>
    </template>
    <template #default>
      <div
        class="processing-tv360-dialog__description"
        v-html="displayMessageHtml"
      ></div>
    </template>
    <template #footer>
      <div class="processing-tv360-dialog__buttons">
        <van-button
          @click="handleClose()"
          class="processing-tv360-dialog__btn processing-tv360-dialog__btn--close"
        >
          {{ $t("close") }}
        </van-button>
      </div>
    </template>
  </van-dialog>
</template>

<script>
import { Dialog, Button } from "vant";

export default {
  name: "ProcessingTV360Dialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  watch: {
    isShow(value) {
      this.showNotify = value;
    },
  },
  computed: {
    displayTitle() {
      return this.title && this.title.length > 0
        ? this.title
        : this.$t("tv360.processing_title");
    },
    displayMessage() {
      return this.message && this.message.length > 0
        ? this.message
        : this.$t("tv360.processing_message");
    },
    displayMessageHtml() {
      const text = this.displayMessage || "";
      const escaped = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
      return escaped.replace(/\r\n|\r|\n/g, "<br/>");
    },
  },
  mounted() {
    this.showNotify = this.isShow;
  },
  data() {
    return {
      showNotify: false,
    };
  },
  created() {
    this.showNotify = this.isShow;
  },
  methods: {
    handleClose() {
      this.showNotify = false;
      this.$emit("update:isShow", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.processing-tv360-dialog {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 16px;
  width: 90vw !important;
  .van-dialog__header {
    padding: 20px 0 0px 0;
  }

  .processing-tv360-dialog__icon {
    display: flex;
    justify-content: center;
    padding-top: 0px;
    padding-bottom: 6px;

    img {
      width: 48px;
      height: 48px;
    }
  }

  .processing-tv360-dialog__title {
    color: #000;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    padding: 0 16px 0px 16px;
  }

  .processing-tv360-dialog__description {
    color: #000;
    text-align: center;
    font-size: 13px;
    font-style: normal;
    padding: 0 12px 0px 12px;
  }

  .processing-tv360-dialog__buttons {
    display: flex;
    justify-content: center;
    padding: 8px 24px 16px 24px;

    .processing-tv360-dialog__btn {
      min-width: 120px;
      padding: 0 24px;
      height: 30px;
      border-radius: 22px;
      font-size: 14px;
    }

    .processing-tv360-dialog__btn--close {
      background: #b81627;
      color: #fff;
      border: none;
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    }
  }
}
</style>
